import { memo, useState, useEffect } from "react";
import Utils, { parseCommands } from "../../../Utils";
import { StyledContainer } from "./styles";
import classnames from "classnames";

function ParsedBeatsBox({ sceneCommands, proseMode }) {
  const [showBeats, setShowBeats] = useState(false);
  const parsedCommands = parseCommands(sceneCommands);
  const beats = parsedCommands.beats;
  const beatsHeader = parsedCommands.header;

  // Listen for changes to sceneCommands
  useEffect(() => {
    // If sceneCommands is empty, hide the beats
    if (sceneCommands === "") {
      setShowBeats(false);
    }
  }, [sceneCommands]);

  return (
    <StyledContainer>
      <div className={classnames({ "beats-hidden": !showBeats })}>
        {!showBeats && sceneCommands && (
          <button
            className="show-beats"
            onClick={() => setShowBeats(true)}
          >
            Check Beats
          </button>
        )}
        {showBeats && sceneCommands && (
          <div className="check-beats-box">
            {beatsHeader && (
              <div className="beats-box">
                <h3>Header</h3>
                <p className="tips">The header will be taken into account for each stride (e.g. 1-2)</p>
                <p>{Utils.nl2br(beatsHeader)}</p>
              </div>
            )}
            {beats && (
              <div className="beats-box">
                <h3>Beats</h3>
                <p className="tips">
                  {proseMode.strides === false && <>Beats will be written all at once</>}
                  {proseMode.strides !== false && <>Beats will be written two at a time (e.g. 1-2)</>}
                </p>
                <ol>
                  {beats.map((beat, index) => {
                    // Use a regular expression to match and remove any leading number and period
                    const cleanedBeat = beat.replace(/^\d+\.\s*/, "");

                    return <li key={index}>{cleanedBeat}</li>;
                  })}
                </ol>
              </div>
            )}
            <button
              className="hide-beats"
              onClick={() => setShowBeats(false)}
            >
              Hide
            </button>
          </div>
        )}
      </div>
    </StyledContainer>
  );
}

export default memo(ParsedBeatsBox);
